import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, Linkedin, Mail, MessageCircle } from "lucide-react";
import { COLORS } from '../config/theme';
import { BRAND } from '../config/brand';

const FOOTER = {
  bg: COLORS.primary,
  text: '#F5F1E8',
  muted: '#B4BDC8',
  line: '#2A3B52',
};

const FooterLink = ({ href, icon: Icon, children }) => (
  <a
    href={href}
    target={href.startsWith('mailto:') ? undefined : '_blank'}
    rel="noopener noreferrer"
    className="inline-flex items-center gap-2 hover:underline"
    style={{ color: FOOTER.muted }}
  >
    <Icon className="h-4 w-4" style={{ color: COLORS.accentLight }} />
    {children}
  </a>
);

const Footer = () => {
  return (
    <footer style={{ backgroundColor: FOOTER.bg, color: FOOTER.text }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-10 pb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

          {/* Colonna sinistra – Brand */}
          <div>
            <img
              src={`${process.env.PUBLIC_URL || ""}/logo-light.svg`}
              alt={`${BRAND.productName} - ${BRAND.companyName}`}
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm max-w-sm" style={{ color: FOOTER.muted }}>
              Il motore di ricerca delle gare d&apos;appalto di {BRAND.companyName}.
              Consulenza strategica negli appalti pubblici, al fianco delle imprese dal 2005.
            </p>
            {/* PENDING: link al nuovo sito, visibile quando BRAND.siteUrl sarà configurato */}
            {BRAND.siteUrl && (
              <a
                href={BRAND.siteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-3 inline-flex items-center gap-1 text-sm font-semibold hover:underline"
                style={{ color: COLORS.accentLight }}
              >
                {BRAND.siteUrl.replace(/^https?:\/\//, '').replace(/\/$/, '')}
                <ExternalLink className="h-3.5 w-3.5 opacity-70" />
              </a>
            )}
          </div>

          {/* Colonna destra – Contatti & legale */}
          <div className="md:text-right">
            <p className="text-sm font-semibold mb-3" style={{ color: FOOTER.text }}>
              Contatti
            </p>

            <div className="flex flex-col md:items-end gap-2 text-sm">
              {/* PENDING: nuova casella email, visibile quando BRAND.contactEmail sarà configurata */}
              {BRAND.contactEmail && (
                <FooterLink href={`mailto:${BRAND.contactEmail}`} icon={Mail}>
                  {BRAND.contactEmail}
                </FooterLink>
              )}
              <FooterLink href={BRAND.social.whatsapp} icon={MessageCircle}>
                WhatsApp
              </FooterLink>
              <FooterLink href={BRAND.social.linkedin} icon={Linkedin}>
                LinkedIn
              </FooterLink>
            </div>

            <div className="mt-5 flex flex-col md:items-end gap-1 text-sm">
              <Link to="/privacy" className="hover:underline" style={{ color: FOOTER.muted }}>
                Privacy Policy
              </Link>
              <Link to="/cookie-policy" className="hover:underline" style={{ color: FOOTER.muted }}>
                Cookie Policy
              </Link>
              <Link to="/termini" className="hover:underline" style={{ color: FOOTER.muted }}>
                Termini e Condizioni
              </Link>
            </div>
          </div>
        </div>

        <div
          className="mt-8 pt-5 border-t text-xs flex flex-col md:flex-row md:justify-between gap-2"
          style={{ borderColor: FOOTER.line, color: FOOTER.muted }}
        >
          <span>
            © {new Date().getFullYear()} {BRAND.legalName}
          </span>
          <span>
            P. IVA {BRAND.vatNumber} · {BRAND.address}
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
